import { useQuery } from '@tanstack/react-query'
import { useShallow } from 'zustand/react/shallow'
import { liveDetailPeopleService } from '../../../../services/lives/lives-details-peoples'
import { useGlobalStore } from '../../../../store/global-store'

export const ONE_LIVE_DETAIL_PEOPLE = 'getOneLiveDetailPeople'

export const useGetOneLiveDetailPeopleByUserId = (userId: number) => {
  const { liveId } = useGlobalStore(
    useShallow((state) => ({
      liveId: state.liveId,
    })),
  )

  const { data, refetch } = useQuery({
    queryKey: [ONE_LIVE_DETAIL_PEOPLE, { userId, liveId }],
    staleTime: 0,
    queryFn: () => {
      return liveDetailPeopleService.getByUserId({
        userId: Number(userId),
        liveId: Number(liveId),
      })
    },
  })

  return {
    oneDetailPeople: data?.data,
    refetch,
  }
}
